import api from "./api";
import auth from "./auth";

export default {
    getList(page) {
        return new Promise((resolve, reject) => {
            api.get(
                "feedback-service/cms/feedback/hotline/list/" + page,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    console.log(errors);
                    return reject(status, errors);
                });
        });
    },
    getInfo(uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                "feedback-service/cms/feedback/hotline/view/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    console.log(errors);
                    return reject(status, errors);
                });
        });
    },
    createHotline(hotline) {
        return new Promise((resolve, reject) => {
            api.post(
                "feedback-service/cms/feedback/hotline/create",
                hotline,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    return reject(status, errors);
                });
        });
    },
    updateHotline(uuid, hotline) {
        return new Promise((resolve, reject) => {
            api.post(
                "feedback-service/cms/feedback/hotline/update/" + uuid,
                hotline,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    console.log(errors);
                    return reject(status, errors);
                });
        });
    },
    deleteHotline(uuid) {
        return new Promise((resolve, reject) => {
            api.delete(
                "feedback-service/cms/feedback/hotline/delete/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    console.log('success: ', response);
                    return resolve(response);
                })
                .catch((status, errors) => {
                    console.log('err: ', errors);
                    return reject(status, errors);
                });
        });
    }
};
